/*
 * Indexed with a computed key — a draft order's `status` off the feed. Declared
 * with the app's open-key pattern, matching `../orders/constants`: the `_LITERAL`
 * const keeps a literal-key read narrow, while the `Record<string, … | undefined>`
 * arm makes a computed-key read `… | undefined`, which is what an unlisted status
 * yields.
 */
const STATUS_COLORS_LITERAL = {
    'new': 'blue',
    'accepted': 'blue',
    'error': 'error',
    'unaccepted': 'error',
    'lost/stolen': 'error',
    'late delivery': 'error',
    'error_cancelled': 'error',
    '>25% damaged/spoiled/unsafe/incomplete': 'error',
    '<25% damaged/spoiled/unsafe/incomplete': 'error',
    'reshipped': 'yellow',
    'never arrived': 'error',
    'incomplete delivery': 'negative',
    'exported': 'warning',
    'sent': 'yellow',
    'shipped': 'yellow',
    'processed': 'yellow',
    'in_process': 'yellow',
    'delivered': 'yy',
    'cancelled': 'zz',
    'partially-fulfilled': 'error',
    'unfulfilled': 'error'
}

export const statusColors: typeof STATUS_COLORS_LITERAL & Record<string, string | undefined> =
  STATUS_COLORS_LITERAL;
